import request from 'api/request';

export default function sendChatMessage(data) {
  return request({ url: `/chat/messages`, method: 'POST', data });
}
